import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class SetManagerUser extends Component {
    state = {
        params: {},
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const { requestPayManagerUserId, requestPayManagerUserInfo, hospitalDepartmentId } = record;
        this.setState({
            record,
            params: {
                hospitalDepartmentId,
                requestPayManagerUserId,
                requestPayManagerUserName: requestPayManagerUserInfo ? requestPayManagerUserInfo : undefined,
            },
        }, () => {
            this.setState({ visible: true });
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { params } = this.state;
        const { requestPayManagerUserId } = params;
        if (!requestPayManagerUserId) {
            message.warning('请选择科室请款负责人');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.setManagerUser,
            data: {
                ...params
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (option, key) => {
        const { params } = this.state;
        const { value: id, text: name } = option;
        params[`${key}Id`] = id;
        params[`${key}Name`] = name;
        this.setState({params})
    }

    render() {
        const { visible, loading, params, record:{ hospitalName, departmentLocalName } } = this.state;
        const { requestPayManagerUserName } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title='配置科室请款负责人'
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="420px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                    <div className="item-left">医院名称:</div>
                                    <div className="item-right">{hospitalName}</div>
                                </li>
                                <li className="modal-item">
                                    <div className="item-left">科室名称:</div>
                                    <div className="item-right">{departmentLocalName}</div>
                                </li>
                            <li className="modal-item">
                                <div className="item-left">{asterisk}科室请款负责人:</div>
                                <div className="item-right">
                                    <SearchRetrieve
                                        keyword='keyword'
                                        style={{ width: 130 }}
                                        placeholder="输入姓名/工号检索"
                                        value={requestPayManagerUserName}
                                        params={{ limit: 20, dimissionStatus: 'WORKING' }}
                                        url={API_URL.investigation.queryUserByKey}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                        onChange={option => this.handleChange(option, 'requestPayManagerUser')}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default SetManagerUser;


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/SetManagerUser.js